import { OverlayComponent } from '@my-backoffice/app/shared/components/overlay/overlay.component';
import { AppOverlayService } from '@my-backoffice/app/shared/services/modal-services/app-overlay/app-overlay.service';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'app-my-qima',
  standalone: true,
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterOutlet, OverlayComponent],
})
export class AppComponent implements OnInit {
  public isLoading: boolean = false;

  public constructor(
    private readonly _changeDetectorRef: ChangeDetectorRef,
    private readonly _appOverlayService: AppOverlayService
  ) {}

  public ngOnInit(): void {
    this._watch();
  }

  private _watch(): void {
    this._appOverlayService.isLoading$.pipe(untilDestroyed(this)).subscribe((isLoading: boolean): void => {
      this.isLoading = isLoading;
      this._changeDetectorRef.detectChanges();
    });
  }
}
